import React from 'react'
import classNames from 'classnames'
import injectStyles from 'react-jss'

import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import SearchBox from '../../../../../Components/FilterAndPaginationComponent/SearchBox'
import Presets from '../Presets'
import { styles } from './styles'

const SearchAndFilters = props => {
  const {
    filters = [],
    classes,
    className,
    onChange,
    searchText,
    suggestions,
    activeTags,
    onRemoveTag,
    onAddTag,
    onPressInput,
    onChangePreset,
    presets,
    presetValue,
  } = props

  return (
    <div className={classes.wrapper}>
      <div
        className={classNames(
          {
            [classes.container]: true,
          },
          className,
          'SearchAndFilters',
        )}
      >
        {filters.length
          ? filters.map((filter, i) => {
              if (filter.config.type === 'select') {
                return (
                  <form className={classes.root} key={i}>
                    <div className={classes.formControl}>
                      <FormControl>
                        <InputLabel
                          shrink
                          id={`${filter.data.label}-simple`}
                          htmlFor={`${filter.data.label}-simple`}
                        >
                          {filter.data.label}
                        </InputLabel>
                        <Select
                          labelId={`${filter.data.label}-simple`}
                          value={filter.data.selectedValue}
                          onChange={event => {
                            onChange({
                              value: event.target.value,
                              label: filter.data.label,
                              data: filter.data,
                              config: filter.config,
                              event,
                            })
                          }}
                          input={
                            <Input
                              name={filter.data.label}
                              id={`${filter.data.label}-simple`}
                            />
                          }
                          displayEmpty
                        >
                          <MenuItem value="All">
                            <em>All</em>
                          </MenuItem>
                          {filter.data.options.map(option => (
                            <MenuItem value={option.value} key={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </form>
                )
              } else {
                return null
              }
            })
          : null}
      </div>
      <div className={classes.searchContainer}>
        <SearchBox
          inputClassName={classNames(classes.searchBox)}
          onChange={onPressInput}
          value={searchText}
          suggestions={suggestions}
          tags={activeTags}
          onAddTag={onAddTag}
          onRemoveTag={onRemoveTag}
        />
        {presets ? (
          <Presets
            presets={presets}
            onChangePreset={onChangePreset}
            presetValue={presetValue}
          />
        ) : null}
      </div>
    </div>
  )
}

export default injectStyles(styles)(SearchAndFilters)
